import { render, staticRenderFns } from "./ReleaseNoteModal.vue?vue&type=template&id=98e0081c&scoped=true"
import script from "./ReleaseNoteModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteModal.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNoteModal.vue?vue&type=style&index=0&id=98e0081c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e0081c",
  null
  
)

export default component.exports